const HelperValidate = {
	
	isString: ( item ) => {
		return HelperValidate.valid( item ) && typeof item === 'string';
	},
	
	valid: ( item ) => {
		return typeof item !== 'undefined' && item !== null && item !== false && item !== 'false' && item !== '';
	},
	
	isValid: ( item ) => {
		return HelperValidate.valid( item );
	}
}

export default HelperValidate
